import { RolexContainer } from './Container'
import { Image } from '@components/gassan-ui'
import { Heading } from '@components/rolex-ui/Heading'
import { Text } from '@components/rolex-ui/Text'
import { getKontentImage } from '@lib/kontent'
import { AssetsElement } from '@lib/kontent/models/Elements'
import { useTranslation } from 'next-i18next'
import { FC } from 'react'

type RolexModelAvailibilityProps = {
  image: AssetsElement
}

export const RolexModelAvailibility: FC<RolexModelAvailibilityProps> = ({ image }) => {
  const { t } = useTranslation('other')
  return (
    <RolexContainer className="grid grid-cols-6 gap-2 bg-white px-4 pt-[60px] md:grid-cols-12 md:pt-[100px]">
      <div
        className="col-span-6 flex flex-col items-center gap-5 text-center md:col-span-8 md:col-start-3 lg:col-span-6 lg:col-start-4"
        id="model-availability"
      >
        <img src="/images/rolex-crown.png" alt="Rolex logo" className="mb-5 h-[60px] w-[60px]" />
        <Heading variant="headline50" as="h3" className="text-rolexBrown">
          {t('modelAvailability')}
        </Heading>
        <Text
          variant="body20"
          weight="light"
          dangerouslySetInnerHTML={{ __html: t('modelAvailabilityDescription') }}
        ></Text>
      </div>
      <div className="col-span-6 md:col-span-8 md:col-start-3">
        <Image
          className="-mt-10 aspect-square md:-mt-20"
          sources={[
            getKontentImage(image.value[0]?.url, {
              width: 768,
            }),
            getKontentImage(image.value[0]?.url, {
              width: 1024,
            }),
          ]}
          placeholderSrc={getKontentImage(image.value[0]?.url, {
            width: 50,
            height: 50,
          })}
          alt={image.value[0]?.description as string}
        />
      </div>
    </RolexContainer>
  )
}
